"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.isCountervalueEnabled = exports.resolveTrackingPair = exports.aliasPair = exports.mapRate = exports.fetchLatest = exports.fetchHistorical = exports.installModule = void 0;
var logs_1 = require("@ledgerhq/logs");
var api_1 = __importDefault(require("../api"));
var weth_1 = __importDefault(require("./weth"));
var ethbtc_1 = __importDefault(require("./ethbtc"));
var modules = [weth_1["default"], ethbtc_1["default"]];
var installModule = function (module) {
    modules.push(module);
};
exports.installModule = installModule;
var fetchHistorical = function (granularity, pair) {
    var fn = api_1["default"].fetchHistorical;
    // a module can override the default api. first who handle wins.
    var m = modules.find(function (m) { return m.handleAPI && m.handleAPI(pair) && m.fetchHistorical; });
    if (m && m.fetchHistorical) {
        fn = m.fetchHistorical;
    }
    return fn(granularity, pair);
};
exports.fetchHistorical = fetchHistorical;
var fetchLatest = function (pairs) { return __awaiter(void 0, void 0, void 0, function () {
    var jobs, _loop_1, i, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                jobs = __spreadArray([
                    {
                        fn: api_1["default"].fetchLatest,
                        pairs: [],
                        indexes: []
                    }
                ], __read(modules
                    .map(function (m) {
                    return m.fetchLatest && {
                        fn: m.fetchLatest,
                        pairs: [],
                        indexes: []
                    };
                })
                    .filter(Boolean)), false);
                _loop_1 = function (i) {
                    var pair = pairs[i];
                    var m = modules.find(function (m) { return m.handleAPI && m.handleAPI(pair); });
                    if (m && m.fetchLatest) {
                        var j = jobs.find(function (j) { return m.fetchLatest === j.fn; });
                        if (j) {
                            j.pairs.push(pair);
                            j.indexes.push(i);
                        }
                    }
                    else {
                        jobs[0].pairs.push(pair);
                        jobs[0].indexes.push(i);
                    }
                };
                for (i = 0; i < pairs.length; i++) {
                    _loop_1(i);
                }
                result = Array(pairs.length).fill(0);
                return [4 /*yield*/, Promise.all(jobs
                        .filter(function (j) { return j.pairs.length > 0; })
                        .map(function (j) {
                        return j
                            .fn(j.pairs)
                            .then(function (r) {
                            for (var i = 0; i < j.pairs.length; i++) {
                                result[j.indexes[i]] = r[i];
                            }
                        })["catch"](function (e) {
                            (0, logs_1.log)("error", "latest fetch issue: " + String(e));
                        });
                    }))];
            case 1:
                _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
exports.fetchLatest = fetchLatest;
var mapRate = function (pair, rate) {
    return modules.reduce(function (rate, m) { return (m.mapRate ? m.mapRate(pair, rate) : rate); }, rate);
};
exports.mapRate = mapRate;
var aliasPair = function (pair) {
    return modules.reduce(function (pair, m) { return (m.aliasPair ? m.aliasPair(pair) : pair); }, pair);
};
exports.aliasPair = aliasPair;
var resolveTrackingPair = function (pair) {
    return modules.reduce(function (pair, m) { return (m.resolveTrackingPair ? m.resolveTrackingPair(pair) : pair); }, pair);
};
exports.resolveTrackingPair = resolveTrackingPair;
var isCountervalueEnabled = function (c) {
    return !c.disableCountervalue ||
        modules.some(function (m) { return m.handleCountervalue && m.handleCountervalue(c); });
};
exports.isCountervalueEnabled = isCountervalueEnabled;
//# sourceMappingURL=index.js.map